import { useToasts, ToastConsumer } from "react-toast-notifications";
import { Notification } from "../Components/Notifications/interface";

let notification: Notification

export const useNotifications = () =>{
  const { addToast,removeToast } = useToasts();

  const onCloseToast = (id:string) =>{
    const element = document.getElementById(id)
    element && element.remove()
  }

 const resultError = () =>{
  notification={type:"error",title:"Error",message:"Se ha producido un error al recibir los datos.", onClose:onCloseToast}
  return addToast(notification,{appearance: 'error',autoDismiss: false})
}

const exceptionError = (exception:any) => {
  if(exception)
  {
    notification={type:"error",title:(`${exception.title} (${exception.code || ''})`),message:exception.message, onClose:onCloseToast}
    return exception && addToast(notification,{appearance: 'error',autoDismiss: false})
  }
}

const launchNotification = (notification: Notification, autoDismiss?:boolean) =>{
  notification={type:notification.type,title:notification.title,message:notification.message, onClose:autoDismiss===false ? onCloseToast : undefined}
  return addToast(notification, autoDismiss===false ? {appearance: 'error',autoDismiss: false} : undefined);
}

  return {...{resultError:resultError, exceptionError:exceptionError, launchNotification}}
}